<template>
  <v-row justify="center">
    <v-dialog
      v-model="modalStatus"
      persistent
      width="70%"
    >
      <v-card outlined>
        <v-card-title class="d-flex align-center">
          <span class="text-h6">Faça o upload do arquivo para adicionar a solicitação.</span>
          <v-spacer></v-spacer>
          <v-btn icon color="grey darken-2" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>


        <v-card-text>
          <v-row>
            <v-col cols="9">
              <v-file-input
                v-model="file"
                label="Escolher arquivo"
                dense
                outlined
                accept=".csv, .xlsx"
              />
            </v-col>

            <v-col cols="2" class="text-right">
              <div class="d-flex mb-4">
                <v-btn color="primary" class="mr-2" @click="downloadTemplate(automation)">
                  <v-icon left>mdi-download</v-icon> Modelo XLSX
                </v-btn>
                <v-btn color="success" :loading="loading" @click="sendFile">
                  <v-icon left>mdi-magnify</v-icon> Buscar
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-subtitle class="d-flex align-center text-subtitle-1 font-weight-medium pb-2">
          {{ title }}
        </v-card-subtitle>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="importedData"
            :search="search"
            class="elevation-5"
            :loading="loading"
          >
            <template v-slot:item.nr_linha="{ item }">
              {{item.ddi}} ({{item.ddd}}) {{item.nr_linha}}
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-text v-if="importedData.length">
          <v-row justify="end">
            <v-col cols="auto">
              <v-btn color="success" @click="confirmImport">
                <v-icon left>mdi-database-import</v-icon> Confirmar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { AUTOMATION_CANCEL_LINE } from "../../helpers/constants";
import automation from "../../store/automation";

export default {
  props: {
    title: {
      default: "Itens Identificados",
      type: String
    },
    automation: {
      default: AUTOMATION_CANCEL_LINE,
      type: Number
    }
  },
  data() {
    return {
      modalStatus: true,
      search: '',
      file: null,
      loading: false,
      importedData: [
      ],
      headers: [
        { text: 'Linha', value: 'nr_linha', align: 'center' },
        { text: 'Responsável', value: 'nome_completo', align: 'center' },
      ],
    };
  },
  computed: {
    ...mapState("solicitation", ["response_import"]),
  },
  methods: {
    ...mapActions("solicitation", ["sendImportDataSolicitation","exportFileImport"]),

    closeDialog() {
      if (this.importedData.length > 0) {
        this.$swal({
          title: 'Tem certeza que deseja fechar?',
          text: 'Os dados importados serão perdidos.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit('closeDialog', false);
          }
        });
      } else {
        this.$emit('closeDialog', false);
      }
    },
    async downloadTemplate(automationSelected) {
      try {
        await this.exportFileImport({automation: automationSelected});
      } catch (err) {
        await this.$swal('Erro ao importar', err.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async sendFile() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('automation', this.automation);
      this.loading = true;
      try {
        const result = await this.sendImportDataSolicitation(formData);
        if (result?.error) {
          await this.$swal('Erro ao importar', "Foram encontrados erros no arquivo de importação. Verifique o download retornado.", 'warning');
        }
        this.importedData = this.response_import;
      } catch (err) {
        await this.$swal('Erro ao importar', err.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async confirmImport() {
      this.$emit('importValues', this.importedData);
    },
  },
};
</script>

<style scoped>
</style>